<template>
  <a-layout-content>
    <div class="home_wrapper">
      <div class="tap">个人工作进展</div>
      <div class="home_top">
        <a-select :defaultValue="statusValue" style="width: 120px;margin-right:16px;" @change="statusChange">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">个人</a-select-option>
          <a-select-option value="2">系统</a-select-option>
        </a-select>
        <span class="label">标签:</span>
        <tag v-for="(item, index) in tagsList" :key="index" :code="item.id" @change="tagsChange" style="margin-right:5px;">{{ item.name }}</tag>
      </div>
      <div class="home_content">
        <a-row>
          <a-col :span="18">
            <dataItem :companyNotes="companyNotes" :loading="loading" @delete="initialize" @update="updateData"></dataItem>
            <div class="load_more" v-show="companyNotes.length != 0 && load_more">
              <a-button class="load_more_btn" :loading="loading" @click="loadMore">加载更多</a-button>
            </div>
          </a-col>
          <a-col :span="6"></a-col>
        </a-row>
      </div>
    </div>
  </a-layout-content>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import dataItem from 'components/home/dataItem'
import tag from 'components/base/tag'
import { getCompanyNotes } from '@/api/work'
import { tagList } from '@/api/tags'
export default {
  components: {
    dataItem,
    tag
  },
  data() {
    return {
      statusValue: '1',
      loading: false,
      companyNotes: [],
      tagsList: [],
      tags: [],
      page: 1,
      pageSize: 25,
      load_more: true,
      basePath: '/components/breadcrumb',
      routes: [
        {
          path: 'index',
          breadcrumbName: '首页'
        },
        {
          path: 'first',
          breadcrumbName: '一级面包屑'
        },
        {
          path: 'second',
          breadcrumbName: '当前页面'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getCompanyNotes()
    this.tagList()
  },
  methods: {
    statusChange(value) {
      this.statusValue = value
      this.page = 1
      this.companyNotes = []
      this.getCompanyNotes()
    },
    tagsChange(obj) {
      if (obj.flag) {
        this.tags.push(obj.code)
      } else {
        this.tags.splice(this.tags.indexOf(obj.code), 1)
      }
      this.page = 1
      this.companyNotes = []
      this.getCompanyNotes()
    },
    tagList() {
      tagList('notes').then(res => {
        this.tagsList = res.data
      })
    },
    loadMore() {
      ++this.page
      this.getCompanyNotes()
    },
    async getCompanyNotes() {
      this.loading = true
      const res = await getCompanyNotes({
        type: this.statusValue,
        tagIds: this.tags.join(','),
        searchUserId: this.$route.query.id,
        page: this.page,
        pageSize: this.pageSize
      })
      this.loading = false
      if (res.code === 200) {
        if (res.data.list) {
          this.load_more = true
          let list = res.data.list
          list.forEach(item => {
            item.isEdit = false
            item.isComent = false
            item.isShow = false
            item.isunfold = true
          })
          // list = list.filter(item => item.owners)
          this.companyNotes = this.companyNotes.concat(list)
          if (this.page * this.pageSize >= res.data.total) {
            this.load_more = false
          }
        } else {
          this.load_more = false
        }
      } else {
        this.companyNotes = []
      }
    },
    initialize(id) {
      this.companyNotes.forEach((item, index) => {
        if (item.id === id) {
          this.companyNotes.splice(index, 1)
        }
      })
    },
    async updateData(id) {
      const res = await getCompanyNotes({
        type: this.statusValue, //这里用5@qq.com测出来一个bug
        tagIds: this.tags.join(','),
        searchUserId: this.$route.query.id,
        page: 1,
        pageSize: this.companyNotes.length
      })
      if (res.code === 200) {
        if (res.data.list) {
          let list = res.data.list
          list.forEach((item, index) => {
            item.isEdit = false
            item.isComent = false
            item.isShow = false
            item.isunfold = true
            if (item.id === id) {
              const targetIndex = this.companyNotes
                .map(item => {
                  return item.id
                })
                .indexOf(id)
              this.companyNotes.splice(targetIndex, 1, item)
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.home_wrapper {
  background: #fff;
  font-size: 12px;
  padding: 16px;
  min-width: 1160px;
  min-height: 100vh;
  .tap {
    width: 200px;
    text-align: center;
    padding-bottom: 5px;
    border-bottom: 2px solid #1890ff;
    margin-bottom: 20px;
  }
  .home_top {
    color: #000;
    .label {
      margin: 0 16px;
    }
  }
  .home_content {
    padding-bottom: 40px;
    .load_more {
      text-align: center;
      .load_more_btn {
        width: 100%;
      }
    }
  }
}
</style>
